"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushbuttonHref = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_jss_1 = __importDefault(require("react-jss"));
const pushbuttonHref_style_1 = __importDefault(require("./pushbuttonHref.style"));
const PushbuttonHref = ({ classes, children, href, buttonRef: ref = null, primary = false, secondary = false, warning = false, disabled = false, external = false, prefix = null, suffix = null }) => {
    const buttonChildren = react_1.useMemo(() => (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [prefix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.prefix }, { children: prefix }), void 0),
            jsx_runtime_1.jsx("span", Object.assign({ className: classes.text }, { children: children }), void 0),
            suffix && jsx_runtime_1.jsx("span", Object.assign({ className: classes.suffix }, { children: suffix }), void 0)] }, void 0)), [children, classes.prefix, classes.suffix, classes.text, prefix, suffix]);
    const rootPropsShared = {
        className: classes.root,
        'data-is-primary': primary,
        'data-is-secondary': secondary,
        'data-is-warning': warning
    };
    if (disabled) {
        return (jsx_runtime_1.jsx("div", Object.assign({}, rootPropsShared, { "data-is-disabled": "true" }, { children: buttonChildren }), void 0));
    }
    const rootProps = {
        ...rootPropsShared,
        href,
        role: 'button',
        ref
    };
    if (external) {
        rootProps.rel = 'external';
        rootProps.target = '_blank';
    }
    return jsx_runtime_1.jsx("a", Object.assign({}, rootProps, { children: buttonChildren }), void 0);
};
exports.PushbuttonHref = PushbuttonHref;
exports.default = react_jss_1.default(pushbuttonHref_style_1.default)(exports.PushbuttonHref);
//# sourceMappingURL=index.js.map